<template>
  <span
    class="mr-1 align-middle text-white rounded-full inline-flex items-center justify-center leading-none relative"
    :class="getStyle(styles, 'container')"
  >
    <img src="@/assets/img/gradients/hard/gradient-2.jpg" class="absolute rounded-full w-full h-full top-0 left-0" v-if="color === 'base'">

    <span class="relative">
      <slot />
    </span>
  </span>
</template>

<script lang="ts" setup>
import { defineStyles, getStyle } from '@/utils/useStyles'

const props = withDefaults(defineProps<{
  size?: '4xs' | '3xs' | '2xs' | 'xs' | 'sm' | 'base' | 'md'
  color?: 'charcoal' | 'base'
}>(), {
  size: 'base',
  color: 'charcoal'
})

const styles = computed(() => defineStyles({
  container: {
    size: {
      '4xs': 'text-5xs font-bold size-1.5',
      '3xs': 'text-5xs font-bold size-3',
      '2xs': 'text-4xs font-bold size-5',
      xs: 'text-3xs font-bold size-6',
      sm: 'text-3xs font-bold size-7',
      base: 'text-3xs font-medium size-7',
      md: 'text-3xs font-medium size-8',
    },
    color: {
      charcoal: 'bg-charcoal-950',
      base: 'bg-transparent'
    }
  }
}, props))
</script>